import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    detailsbottom:true,
    mdnavaction:null,
    routerpath:null,
    active:null,
    htmlcontent:null,
  },
  mutations: {
    htmlcontent:function(state,news){
      state.htmlcontent=news
    },
    routerpath:function(state,news){
      state.routerpath=news
    },
    active:function(state,news){
      state.active=news
    },
    mdnavaction:function(state,news){
      state.mdnavaction=news
    },
    detailsbottom:function(state,news){
      state.detailsbottom=news
    },
    isShowSwiper:function(state,news){
      state.isShowSwiper=news
    }
  },
  actions: {
  },
  modules: {
  }
})
